<div class='widget-header'>

  <ng-container *ngIf='showOptButton'>
    <div class='label'>
      <button (click)='clickCreateOpt.emit()'
              [disabled]='disabledOptButton'
              class='btn btn-sm btn-link m-0 p-0 mb-4 d-flex align-items-center'>
        {{ label }}
        <pt-icon class="ms-1" [key]="IconEdit"></pt-icon>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf='!showOptButton'>
    <div class='label fw-bold'>{{ label }}</div>

    <div *ngIf='help' class='help'>
      <pt-w-help [help]='help'></pt-w-help>
    </div>

    <pt-widget-action
      (clickCancel)='clickResetWidget.emit(true)'
      (clickEdit)='clickEditWidget.emit(true)'

      (clickReload)='clickReloadWidget.emit(true);'
      (clickSave)='clickSaveWidget.emit(true)'
      [disabledCancel]='disabledCancelButton'
      [disabledEdit]='disabledEditButton'
      [disabledReload]='disabledReloadButton'

      [disabledSave]='disabledSaveButton'
      [showCancel]='showCancelButton'
      [showEdit]='showEditButton'
      [showIcon]='true'

      [showLoader]='loading'
      [showReload]='showReloadButton'
      [showSave]='showSaveButton'
      actionStyle='BUTTON'>
    </pt-widget-action>

    <button
      (click)='clickResetAll.emit(true)'
      *ngIf="enableResetAll"
      [disabled]='disabledResetAllButton'
      class='btn btn-sm btn-success btn-widget'>
      {{ 'BUTTON.RESET_ALL' | translate }}
    </button>

    <div *ngIf='showCommentButton' class='comment'>

      <div class="w-header-btn-link enabled"
           style="display: flex; flex-direction: row; gap: 2px;"
           [ngbTooltip]="'TOOLTIP.COMMENTS' | translate "
           (click)='clickCommentWidget.emit()'>
        {{'TOOLTIP.COMMENTS' | translate}}
        <pt-icon *ngIf="comment?.length > 0 || unsavedComment?.length > 0; else noComment"
                 [key]="'chatbox-ellipses'"
                 [size]='22'></pt-icon>
        <ng-template #noComment>
          <pt-icon [key]="'chatbox-ellipses-outline'" [size]='22'></pt-icon>
        </ng-template>
      </div>

      <pt-icon
        *ngIf="comment !== unsavedComment"
        [ngbTooltip]="'Commento modificato. Salva per rendere permanenti le modifiche.'"
        container="body"
        [key]="'warning'" class="text-warning ms-2" [size]='22'>
      </pt-icon>

    </div>

  </ng-container>
</div>

<div *ngIf='warning'>
  <div class='alert alert-warning d-flex p-1'>
    <pt-icon [key]='IconWarning'
             [size]='IconSize'
             class='widget-warning-icon-color'>
    </pt-icon>
    <label class='warning-label'>{{ warning }}</label>
  </div>
</div>
